var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background" },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c("div", { staticClass: "header" }, [
            _c(
              "div",
              { staticClass: "header-title" },
              [
                _c("el-button", { on: { click: _vm.backToRecruitmentIndex } }, [
                  _vm._v("戻る"),
                ]),
                _vm._v(" 求人情報編集"),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("RecruitmentForm", {
            attrs: {
              "show-form": _vm.showForm,
              form: _vm.form,
              "submit-btn-name": _vm.submitBtnName,
              loading: _vm.loading,
            },
            on: {
              backToUserIndex: _vm.backToRecruitmentIndex,
              postFormSubmit: _vm.postFormSubmit,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "確認",
            visible: _vm.waitDialogVisible,
            width: "30%",
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waitDialogVisible = $event
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.submitBtnName) + "中！")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }